import React from 'react'
import AdminEventListItem from './AdminEventListItem'
import Grid from '@material-ui/core/Grid'
import _ from 'lodash'
import {defaultGridSettings} from '../../../js/settings/grid'

const AdminEventList = (props) => {

    const events = props.adminEvents
    const { canidateIds } = props

    const checkEventHasCanidate = (hasCanidates, eventId) =>{
        if(hasCanidates){
            return canidateIds[eventId]
        } else {
            return null
        }
    }
    let eventHasCanidates = null
    
    return (
        <Grid container {...defaultGridSettings.container} >
        {_.map(events, (event, key) => {
    
            //check event has canidates / true has / false hasn't
            if(canidateIds!=null) 
            {eventHasCanidates = canidateIds.hasOwnProperty(event.data.id)}
           
            return(
                <Grid key={key} item {...defaultGridSettings.item} >
                    <AdminEventListItem
                        key={key}
                        event={event}
                        canidates={checkEventHasCanidate(eventHasCanidates, event.data.id)}
                    />
                </Grid>
                )
        })

        }
        </Grid>
    )
}


export default AdminEventList


// WEBPACK FOOTER //
// ./src/Container/Content/AdminEvents/AdminEventList.js